import React, {useEffect} from "react";

import Script from "react-inline-script"

function B24form(props) {

    let HTML = ` `
    useEffect(() => {


    }, [])
    return (

        <script data-b24-form="inline/26/vmsv81" data-skip-moving="true">
            {init()}
        </script>


    )
}

function init() {
    (function (w, d, u) {
        var s = d.createElement('script');
        s.async = true;
        s.onload = () => {
          //  alert("load")
        }
        s.src = u + '?' + (Date.now() / 180000 | 0);
        var h = d.getElementsByTagName('script')[0];
        h.parentNode.insertBefore(s, h);
    })(window, document, 'https://bitrix.cmrt.ru/upload/crm/form/loader_26_vmsv81.js')
}
export {B24form}